import { useEffect, useState } from 'react';
import io from 'socket.io-client';

const useSocket = (serverUrl) => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const socket = io(serverUrl, {
      transports: ['websocket'], // Esto fuerza el uso de WebSockets; quítalo si quieres permitir otros transportes
    });
    
    socket.on('connect', () => {
      console.log('Connected to the server');
    });

    socket.on('reply', (data) => {
      console.log('Reply from server:', data);
    });

    setSocket(socket);

    return () => socket.disconnect();
  }, [serverUrl]);

  return socket;
};

export default useSocket;